import { useGlobalStore } from '@/store/global/global-store'
import { UserInfo } from '@renderbus/widgets/components/user-info'
import { getAuthStatusTranslate } from '@/helper/get-user-info'
import { redirectToAuth } from '@/helper/redirect-to-auth'
import { navigateToUserCenter } from 'project-config/utils'
import { toLogout } from '@/helper/to-logout'
import { isEn } from 'project-config/utils/env'
import { DataCollector } from '@rayvision/data-collect'

export function UserInfoDropdown() {
  const {
    userInfo,
    isSubAccount,
    isPictureUser,
    currencySymbol,
    userBalance,
    userCredit,
    userCouponCount,
    userCouponPrice,
    userQYCouponPrice,
    userQYCouponCount,
    isDomestic,
    isCertified,
    userLevel,
    userLevelTranslate,
    isStudentValid,
    studentCertifyInfo,
    isPersonal,
    vocherInfo,
    recentExpireDate,
  } = useGlobalStore()

  return (
    <UserInfo
      userInfo={{
        isHideBalance: true,
        isSubAccount: isSubAccount(),
        isPictureUser: isPictureUser(),
        vocherCount: vocherInfo?.effectiveVoucher.length || 0,
        vocherExpireDate: recentExpireDate,
        userName: userInfo?.userName,
        uuid: userInfo?.fatherUuid,
        currencySymbol: currencySymbol(),
        userBalance: userBalance(),
        userCredit: userCredit(),
        userCouponCount: userCouponCount(),
        userCouponPrice: userCouponPrice(),
        qyCoupon: userQYCouponPrice(),
        qyCouponCount: userQYCouponCount(),
        memberLevelTranslate: userLevelTranslate(),
        authStatusTranslate: getAuthStatusTranslate(
          userInfo?.authStatus || 0,
          isStudentValid(),
          isPersonal(),
        ),
        isCertified: isCertified(),
        isDomestic: isDomestic(),
        userLevel: userLevel(),
        userTotalCredit: userInfo?.totalCredit,
        picMemberValidity: userInfo?.picMemberValidity,
      }}
      language={isEn() ? 'en' : 'zh'}
      toAuth={() => void redirectToAuth(userInfo, studentCertifyInfo?.studentBlock)}
      toCoupon={(key) => {
        navigateToUserCenter({
          isDomestic: isDomestic(),
          path: 'coupon',
          searchParams: `activeName=${key}`,
        })
      }}
      toRecharge={() => {
        DataCollector.emit('keypage_click', {
          header_button_type: '顶部导航栏',
          sub_button_type: '个人信息下拉',
          button_name: '充值按钮',
        })
        navigateToUserCenter({
          isDomestic: isDomestic(),
          path: 'topUp',
          target: '_blank',
        })
      }}
      toUserCenter={(to = '') => {
        DataCollector.emit('keypage_click', {
          header_button_type: '顶部导航栏',
          sub_button_type: '个人信息下拉',
          button_name: '个人中心按钮',
        })
        navigateToUserCenter({
          path: to,
        })
      }}
      logout={() => {
        DataCollector.emit('keypage_click', {
          header_button_type: '顶部导航栏',
          sub_button_type: '个人信息下拉',
          button_name: '退出登录按钮',
        })
        void toLogout()
      }}
      toPictureVip={() => {
        DataCollector.emit('keypage_click', {
          header_button_type: '顶部导航栏',
          sub_button_type: '个人信息下拉',
          button_name: '效果图用户开通会员按钮',
        })
      }}
    />
  )
}
